import { render } from "./OrdersDeliveryDashboard.html?vue&type=template&id=fd027908&scoped=true"
import script from "./OrdersDeliveryDashboard.js?vue&type=script&lang=js"
export * from "./OrdersDeliveryDashboard.js?vue&type=script&lang=js"

import "./OrdersDeliveryDashboard.css?vue&type=style&index=0&id=fd027908&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd027908"]])

export default __exports__